import { postJSON, getJSON, queryStringify, getPdf } from "./ajax";

export default class Repository {
  constructor(options = {}) {
    const { noReadGenericApi } = options;
    this._baseUri = noReadGenericApi ? "/api/v1/" : "/api/v1/r/";
  }

  findByFilter(modelName, filter, options) {
    const query = { filter };
    return getJSON(`${this._baseUri}${modelName}${queryStringify(query)}`, options);
  }

  findWhere(modelName, query, options) {
    if(query && query.where && query.limit) {
      query = {
        filter: {
          where: query.where,
          limit: query.limit
        }
      }
    } else if(query && !query.filter) {
      query = { filter: query || {} }
    }
    return getJSON(`${this._baseUri}${modelName}${queryStringify(query)}`, options);
  }

  findOne(modelName, query, options) {
    return this.findWhere(modelName, query, options).then(results => results[0]);
  }

  create(modelName, data, options) {
    return this.execute(modelName, null, "create", data, options);
  }

  execute(modelName, aggregateId, action, data, options) {
    const instance = aggregateId ? "/" + aggregateId : "";
    return postJSON(`/api/v1/${modelName}${instance}/${action}`, data, options);
  }

  getPdf(modelName, action, query, options) {
    query.access_token = options.token
    return getPdf(`/api/v1/${modelName}/${action}/${queryStringify(query)}`);
  }
}



// WEBPACK FOOTER //
// ./src/services/repo.js